

import { useEffect, useState } from "react";
import styles from "./HotelNetwork.module.css";

// const API_BASE_URL = "http://127.0.0.1:8000";
const API_BASE_URL = "https://atlastravelhouse.com";

const HotelNetwork = () => {
  const [hotelBrands, setHotelBrands] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  useEffect(() => {
    const fetchHotelBrands = async () => {
      try {
        const response = await fetch(
          `${API_BASE_URL}/api/hotel-brands/`
        );

        if (!response.ok) {
          throw new Error("Failed to fetch hotel brands");
        }

        const data = await response.json();

        const allBrands = [];

        data.forEach((parent) => {
          if (parent.logo) {
            allBrands.push({
              id: `parent-${parent.id}`,
              name: parent.name,
              logo: parent.logo,
            });
          }

          if (parent.hotel_brands?.length > 0) {
            parent.hotel_brands.forEach((brand) => {
              if (brand.logo) {
                allBrands.push({
                  id: `brand-${brand.id}`,
                  name: brand.name,
                  logo: brand.logo,
                });
              }
            });
          }
        });

        const sortedBrands = allBrands.sort((a, b) =>
          a.name.localeCompare(b.name, undefined, {
            sensitivity: "base",
          })
        );

        setHotelBrands(sortedBrands);
      } catch (error) {
        console.error("Hotel Network Error:", error);
        setError("Unable to load hotel network.");
      } finally {
        setLoading(false);
      }
    };

    fetchHotelBrands();
  }, []);

  const getImageUrl = (logo) => {
    if (!logo) return "";

    if (logo.startsWith("http")) {
      return logo;
    }

    return `${API_BASE_URL}${logo}`;
  };

  return (
    <section className={styles.hotelNetwork}>
      <div className={styles.container}>

        <div className={styles.header}>
          <span className={styles.eyebrow}>
            OUR HOTEL NETWORK
          </span>

          <h2 className={styles.title}>
            Trusted Hospitality Network
          </h2>

          <p className={styles.description}>
            Our experience spans leading hotel brands and hospitality
            properties across India and beyond.
          </p>
        </div>

        {loading && (
          <div className={styles.status}>
            Loading hotel network...
          </div>
        )}

        {error && (
          <div className={styles.status}>
            {error}
          </div>
        )}

        {!loading && !error && hotelBrands.length > 0 && (
          <div className={styles.logoGrid}>
            {hotelBrands.map((brand) => (
              <div
                key={brand.id}
                className={styles.brandCard}
              >
                <img
                  src={getImageUrl(brand.logo)}
                  alt={brand.name}
                  className={styles.brandLogo}
                  loading="lazy"
                />
              </div>
            ))}
          </div>
        )}

      </div>
    </section>
  );
};

export default HotelNetwork;